import axios from "axios";

// When unset (production Worker deploy), use same-origin "/api".
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API,
    withCredentials: true,
});

const asArray = (value) => (Array.isArray(value) ? value : []);

export const authApi = {
    config: () => client.get("/auth/config").then((r) => r.data),
    me: () => client.get("/auth/me").then((r) => r.data),
    login: (email, password) =>
        client.post("/auth/login", { email, password }).then((r) => r.data),
    requestMagicLink: (email) =>
        client.post("/auth/magic-link/request", { email }).then((r) => r.data),
    verifyMagicLink: (token) =>
        client
            .get("/auth/magic-link/verify", { params: { token } })
            .then((r) => r.data),
    requestPasswordReset: (email) =>
        client
            .post("/auth/password-reset/request", { email })
            .then((r) => r.data),
    confirmPasswordReset: (token, new_password) =>
        client
            .post("/auth/password-reset/confirm", { token, new_password })
            .then((r) => r.data),
    logout: () => client.post("/auth/logout").then((r) => r.data),
};

export const usersApi = {
    list: () => client.get("/users").then((r) => r.data),
    create: (data) => client.post("/users", data).then((r) => r.data),
    update: (id, data) => client.put(`/users/${id}`, data).then((r) => r.data),
    remove: (id) => client.delete(`/users/${id}`).then((r) => r.data),
    sendInvite: (id) =>
        client.post(`/users/${id}/send-invite`).then((r) => r.data),
};

export const appsApi = {
    list: () => client.get("/apps").then((r) => r.data),
    create: (data) => client.post("/apps", data).then((r) => r.data),
    update: (id, data) => client.put(`/apps/${id}`, data).then((r) => r.data),
    remove: (id) => client.delete(`/apps/${id}`).then((r) => r.data),
};

export const favApi = {
    list: () => client.get("/favorites").then((r) => r.data),
    add: (id) => client.post(`/favorites/${id}`).then((r) => r.data),
    remove: (id) => client.delete(`/favorites/${id}`).then((r) => r.data),
};

export const launchApi = {
    record: (appId) =>
        client.post("/launches", { app_id: appId }).then((r) => r.data),
    recent: () => client.get("/launches/recent").then((r) => r.data),
};

export const annApi = {
    list: () => client.get("/announcements").then((r) => r.data),
    create: (data) =>
        client.post("/announcements", data).then((r) => r.data),
    remove: (id) =>
        client.delete(`/announcements/${id}`).then((r) => r.data),
};

export const wikiApi = {
    tree: () => client.get("/wiki/tree").then((r) => asArray(r.data)),
    getPage: (slug) => client.get(`/wiki/pages/${slug}`).then((r) => r.data),
    createPage: (data) => client.post("/wiki/pages", data).then((r) => r.data),
    updatePage: (id, data) => client.put(`/wiki/pages/${id}`, data).then((r) => r.data),
    updateContent: (id, data) => client.put(`/wiki/pages/${id}/content`, data).then((r) => r.data),
    deletePage: (id) => client.delete(`/wiki/pages/${id}`).then((r) => r.data),
    search: (q) => client.get("/wiki/search", { params: { q } }).then((r) => asArray(r.data)),
};

export const statsApi = {
    overview: () => client.get("/stats/overview").then((r) => r.data),
};

export default client;
